export default {
	sharingWithMeEmails: state => state.sharingWithMeEmails,
	message: state => state.message,
	userSharingEmails: state => state.userSharingEmails,
	profile: state => state.profile,
	loading: state => state.loading,
	users: state => state.users,
	invoice: state => state.invoice,
	profileUser: state => state.profileUser,
	globalLoading: state => state.globalLoading,
};
